import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="container-page flex min-h-[70vh] flex-col items-center justify-center py-20 text-center">
      <span className="font-heading text-7xl font-black text-primary-100 select-none md:text-9xl">
        404
      </span>
      <h1 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        页面不存在或已被移除
      </h1>
      <p className="mt-2 text-sm text-foreground-500">
        你访问的地址 <span className="font-mono text-foreground-700">{location.pathname}</span> 没有找到对应内容
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          <i className="ri-search-line"></i>
          去搜索视频
        </Link>
      </div>
    </div>
  );
}